import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { InternetChangeModel } from 'app/shared/open-api/data-contracts';
import { Observable } from 'rxjs';
import { ProductsService } from '../services/products.service';

/** Returns the current and available products for the current customer. */
@Injectable()
export class AvailableInternetProductsResolver implements Resolve<InternetChangeModel | null> {
  constructor(private readonly productsService: ProductsService) {}

  resolve(): Observable<InternetChangeModel | null> {
    return this.productsService.getAvailableInternetProducts();
  }
}
